function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.3181 5.50435C10.6689 5.20354 10.4815 4.63395 10.0186 4.59452L7.4758 4.3779L6.48268 2.06648C6.30132 1.64438 5.6957 1.64454 5.51457 2.06674L4.52082 4.38309L1.98208 4.59588C1.51863 4.63472 1.3307 5.20521 1.68225 5.50607L3.61119 7.15693L3.03198 9.60978C2.92632 10.0572 3.41753 10.4099 3.81573 10.1725L5.99831 8.8711L8.1829 10.1737C8.58081 10.411 9.07179 10.0589 8.96681 9.61166L8.39069 7.15693L10.3181 5.50435Z"
  }));
};

export default SvgComponent;